import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import { useSelector, useDispatch } from "react-redux";
import PracticeContainer from "../../containers/PracticeContainer/PracticeContainer";
import Tutorial from "../../containers/TutorialContainer/Tutorial";
import ClassContainer from "../../containers/ClassContainer/ClassContainer";
import LessonContainer from "../../containers/LessonContainer/LessonContainer";
import LeaderboardContainer from "../../containers/LeaderboardContainer/LeaderboardContainer";
import AlertLogOutContainer from "../../containers/AlertLogOutContainer/AlertLogOutContainer";
import SelectCharacterContainer from "../../containers/SelectCharacterContainer/SelectCharacterContainer";
import LoginContainer from "../../containers/LoginContainer/LoginContainer";
import { getAuth } from "firebase/auth";
import { authenticateUser } from "../../redux/reducers/UserReducer";
import { initiateNewRound } from "../../redux/reducers/RoundReducer";
import { getUserById } from "../../api/FakeApi";
import { getQuizNumber } from "../../api/contentApi";

import s from "./style.module.css";

const MainPage = () => {
  const auth = getAuth();
  const authUser = localStorage.getItem("authUser");
  const [QuizNumber, setQuizNumber] = useState(0);
  const mode = useSelector((state) => state.Mode);
  const userInfo = useSelector((state) => state.UserInfo);
  const grade = useSelector((state) => state.PracticeData.grade);
  const dispatch = useDispatch();
  const logout = (e) => {
    auth.signOut().then((response) => {
      dispatch(authenticateUser({ ...userInfo }));
    });
    localStorage.removeItem("authUser");
  };

  useEffect(() => {
    if (authUser !== null) {
      getUserById(authUser).then((res) => {
        dispatch(
          authenticateUser({
            username: res.username,
            character: res.character,
            grade: res.grade,
            completeWeek: res.completeWeek,
          })
        );
        dispatch(initiateNewRound());
      });
    }
    getQuizNumber(grade).then((res) => {
      setQuizNumber(res.length);
    });
  }, [authUser, dispatch, grade]);

  const renderMode = () => {
    if (localStorage.getItem("authUser")) {
      if (mode.mode === 1) {
        switch (mode.step) {
          case 1:
            return <Tutorial />;
          case 2:
            return <ClassContainer />;
          case 3:
            return <LessonContainer QuizNumber={QuizNumber} />;
          case 4:
            return <LeaderboardContainer />;
          case 5:
            return <SelectCharacterContainer />;
          case 6:
            return <AlertLogOutContainer />;
          default:
            return <Tutorial />;
        }
      } else {
        return <PracticeContainer />;
      }
    } else {
      return <LoginContainer />;
    }
  };
  const hours = 1;
  const now = new Date().getTime();
  const setupTime = localStorage.getItem("setupTime");
  if (setupTime == null) {
    localStorage.setItem("setupTime", now);
  } else {
    if (now - setupTime > hours * 60 * 60 * 1000) {
      localStorage.clear();
      localStorage.setItem("setupTime", now);
    }
  }
  return (
    <React.Fragment>
      {!!localStorage.getItem("authUser") && (
        <div
          style={{
            position: "absolute",
            right: 0,
            zIndex: 1,
            color: "#FFFFFF",
          }}
        >
          <span>{localStorage.getItem("authUser")} </span>
          <Button onClick={() => logout()} variant="contained" color="error">
            ออกจากระบบ
          </Button>
          {/* <button onClick={() => logout()}>Logout</button> */}
        </div>
      )}

      <div className={s.Container}>
        <div className={s.BackgroundImg} />
        {/* <video className={s.BackgroundImg} autoPlay loop muted>
          <source src={BgVideo} />
        </video> */}
        {renderMode()}
      </div>
      <div className={s.warning}>
        <h1 style={{ margin: "40vmax 0" }}>Please rotate your device.</h1>
      </div>
    </React.Fragment>
  );
};

export default MainPage;
